<form [formGroup]="filterFormGroup" class="list-work-order-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Users</h3>
    </div>
    <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
      <app-user-search class="search-bar" [userSearchTextForm]="filterFormGroup.controls.userSearchTextForm"></app-user-search>
    </div>
  </div>

  <!-- New: tab bar (Shop users / Other users) -->
  <!-- Tabs + Add New -->
  <div class="tabs-row">
    <mc-tab-bar [currentindex]="currentIndex$ | async">
      <mc-tab
        slot="tab"
        (click)="setTab(0)"
        (keydown.enter)="setTab(0)"
        (keydown.space)="setTab(0)"
        [class.tab-pending]="pendingTabIndex === 0">
        <button class="tab-btn">Shop Users</button>
      </mc-tab>

      <mc-tab
        slot="tab"
        (click)="setTab(1)"
        (keydown.enter)="setTab(1)"
        (keydown.space)="setTab(1)"
        [class.tab-pending]="pendingTabIndex === 1">
        <button class="tab-btn">Internal Users</button>
      </mc-tab>
    </mc-tab-bar>

    <!-- Add New stays here -->
    @if (authPolicy.canAddEditUsers) {
      <mc-button
        label="Add New"
        variant="filled"
        appearance="primary"
        fit="small"
        (click)="navigateToCreate()"
        (keydown)="navigateToCreate()">
      </mc-button>
    }
  </div>

  <!-- ✅ FILTER COMPONENT BACK -->
  <app-user-filters [filterFormGroup]="filterFormGroup" [activeTab]="(currentIndex$ | async) ?? 0"> </app-user-filters>
  <!-- Pass active tab into grid -->
  <app-user-grid
    [filterFormGroup]="filterFormGroup"
    [activeTab]="(currentIndex$ | async) ?? undefined"
    class="table-container"></app-user-grid>
</form>
